var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"currentColor","x":"0.855469","y":"6","width":"5","height":"12","key":0}),React.createElement("rect",{"fill":"currentColor","x":"9.85547","y":"6","width":"5","height":"12","key":1}),React.createElement("rect",{"fill":"currentColor","x":"19.8555","y":"6","width":"5","height":"12","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
